<header>
  <div class="div-header">
    <img class="img-header" src="assets/home/logo-header.svg"
         (click)="onClickHome()" alt="logo-header">
  </div>
</header>
